export default class ProtectionPlusForm {
	constructor() {
		this.parentContainer = document.getElementById('checkoutOrderSummary');
		$(document).ready(() => this.updateEventListeners());
	}

	updateEventListeners() {
		this.parentContainer?.addEventListener('click', event => {
			if (event.target.closest('#removeProtectionPlus')) {
				event.preventDefault();
				this.updatePPIselection(false);
			} else if (event.target.closest('#addProtectionPlusLinkSection')) {
				event.preventDefault();
				this.updatePPIselection(true);
			}
		});
	}

	updatePPIselection(status) {
		const data = { optIn: status, step: this.getCheckoutStep() };
		const url = '/ajax/protectionplus/update-cart';
		$.ajax({
			type: 'POST',
			url,
			data,
			success: response => {
				$('#checkoutSummarySectionContent').html(response);
			},
		});
	}

	getCheckoutStep() {
		if (window.RR_CONFIG.pageType === 'CHECKOUT') {
			return $('#orderSummary').data('checkoutstep');
		}
	}
}
